import { render } from "./TourBookingView.vue?vue&type=template&id=ff17600c"
import script from "./TourBookingView.vue?vue&type=script&lang=js"
export * from "./TourBookingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__